var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15.9823 9.41075C16.3894 8.58482 17.0951 7.96387 17.9725 7.66416C18.3397 7.53842 18.7181 7.49019 19.0948 7.48847V2.58371C19.0948 1.15923 17.9265 0 16.491 0H2.60384C1.16825 0 0 1.15923 0 2.58371V19.8085C0 21.233 1.16825 22.3922 2.60384 22.3922H11.239L11.1453 22.1218C10.7677 21.0289 10.8415 19.861 11.351 18.8284L15.9823 9.41075ZM3.47178 5.16743H13.8871C14.3671 5.16743 14.7551 5.55326 14.7551 6.02867C14.7551 6.50407 14.3671 6.88991 13.8871 6.88991H3.47178C2.99181 6.88991 2.60384 6.50407 2.60384 6.02867C2.60384 5.55326 2.99181 5.16743 3.47178 5.16743ZM3.47178 8.61238H13.0192C13.4992 8.61238 13.8871 8.99822 13.8871 9.47362C13.8871 9.94902 13.4992 10.3349 13.0192 10.3349H3.47178C2.99181 10.3349 2.60384 9.94902 2.60384 9.47362C2.60384 8.99822 2.99181 8.61238 3.47178 8.61238ZM9.5474 17.2248H3.47178C2.99181 17.2248 2.60384 16.8389 2.60384 16.3635C2.60384 15.8881 2.99181 15.5023 3.47178 15.5023H9.5474C10.0274 15.5023 10.4153 15.8881 10.4153 16.3635C10.4153 16.8389 10.0274 17.2248 9.5474 17.2248ZM3.47178 13.7798C2.99181 13.7798 2.60384 13.394 2.60384 12.9186C2.60384 12.4432 2.99181 12.0573 3.47178 12.0573H11.2833C11.7633 12.0573 12.1512 12.4432 12.1512 12.9186C12.1512 13.394 11.7633 13.7798 11.2833 13.7798H3.47178ZM22.2229 12.432L17.5898 21.8531C17.2834 22.474 16.7531 22.9391 16.0961 23.163L14.4548 23.7228C14.3619 23.7547 14.2656 23.7702 14.1727 23.7702C13.8125 23.7702 13.4757 23.5463 13.3525 23.1888L12.7874 21.5602C12.5609 20.9057 12.6052 20.2046 12.9107 19.5854L17.5438 10.1661C17.746 9.75266 18.1001 9.44262 18.5384 9.29276C18.9759 9.14291 19.4472 9.17047 19.8638 9.37372L21.4244 10.129C21.841 10.3306 22.1534 10.6819 22.3045 11.1169C22.4555 11.5518 22.4268 12.0186 22.2229 12.432Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }